export default `
§ sidebar.switch.team: Equipo
§ sidebar.switch.person: Empleado
§ sidebar.buttons.settings: Ajustes
§ sidebar.buttons.print: Impresión
§ sidebar.buttons.share: Share
§ sidebar.buttons.logout: Logout
§ sidebar.filters.all: a todas horas
§ sidebar.filters.year: año
§ sidebar.filters.halfYear: medio año
§ sidebar.filters.month: mes
§ sidebar.filters.week: semana
§ sidebar.team.total: Información general
§ sidebar.team.scope: módulos
§ sidebar.team.author: Personal
§ sidebar.team.type: Tipos de tareas
§ sidebar.team.pr: Inyección de código
§ sidebar.team.day: Por días
§ sidebar.team.week: Por semana
§ sidebar.team.month: Por mes
§ sidebar.team.tree: Archivos
§ sidebar.team.removedTree: Archivos eliminados
§ sidebar.team.files: Ficheros
§ sidebar.team.removedFiles: Archivos eliminados
§ sidebar.team.tasks: Lista de tareas
§ sidebar.team.hours: Horario
§ sidebar.team.commits: All commits
§ sidebar.team.changes: Todos los cambios
§ sidebar.team.words: Palabras populares
§ sidebar.team.top: Concurso
§ sidebar.team.settings: Ajustes
§ sidebar.person.total: Información general
§ sidebar.person.money: Costo del trabajo
§ sidebar.person.speed: Velocidad
§ sidebar.person.day: Por días
§ sidebar.person.week: Por semana
§ sidebar.person.month: Por mes
§ sidebar.person.hours: Horario
§ sidebar.person.commits: All commits
§ sidebar.person.changes: Todos los cambios
§ sidebar.person.words: Palabras populares
§ sidebar.person.settings: Ajustes
`;
